import axios from "axios";

const PREFIJO = "/api/TpDcmtFrm/"

export default {
    tipoTelefono(nombreTipoPersona){
        const dto = {
            dt1:process.env.VUE_APP_PAIS_NAME,
            dt2: nombreTipoPersona
        }
        return axios.post(`${PREFIJO}VmTpTl`,dto);
    }
}